import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { WizardType } from './core/enums/wizard-type.enum';
import { AuthService } from './core/services/auth/auth.service';
import { Globals } from './core/services/globals/globals';
import { WizardTypeService } from './luqas-configuration/services/services/wizard-type/wizard-type.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private _translate: TranslateService,
    private _auth: AuthService,
    private route: ActivatedRoute,
    private globals: Globals,
    private readonly title: Title,
    private readonly wizardTypeService: WizardTypeService,
  ) {
    this.printLuqasWizardVersionNumber();
    this._subscribeToUserLang();
    this._checkAndAddBetaParam();
    this._setBrowserTitle();
  }

  private _setBrowserTitle() {
    const isEmh = this.wizardTypeService.wizardType === WizardType.EMH;
    this.title.setTitle(isEmh ? 'EMH wizard' : 'Luqas wizard');
  }

  private _subscribeToUserLang() {
    this._auth.userLanguage$.subscribe((lang) => {
      if (lang) {
        const semsaLang = `semsa_${lang.id}`;
        console.info(`Language set to: ${semsaLang} (${lang.name})`);
        this._translate.use(semsaLang);
      }
    });
  }

  private _checkAndAddBetaParam() {
    const url = new URL(window.location.href);

    const isBetaHost = Object.values(environment.betaWizardHosts).some((host) =>
      window.location.hostname.includes(host),
    );

    const hasBetaParam = url.searchParams.has('beta');

    if (isBetaHost && !hasBetaParam) {
      url.searchParams.set('beta', 'true');
      window.location.href = url.toString();
    }
  }

  printLuqasWizardVersionNumber() {
    console.log(
      'Luqas Wizard version number: ',
      environment?.luqasWizardVersion,
    );
  }
}
